import { render, staticRenderFns } from "./ReturnOrderPreview.vue?vue&type=template&id=2a5fa924"
import script from "./ReturnOrderPreview.vue?vue&type=script&lang=js"
export * from "./ReturnOrderPreview.vue?vue&type=script&lang=js"
import style0 from "./ReturnOrderPreview.vue?vue&type=style&index=0&id=2a5fa924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports